import jwtDecode from 'jwt-decode';
export function validJwtToken(jwtToken) {
    if (!jwtToken)
        return false;
    return parseJwtToken(jwtToken).exp > Date.now() / 1000;
}
export function parseJwtToken(jwtToken) {
    return jwtDecode(jwtToken);
}
//# sourceMappingURL=jwt_token.js.map